import axios from 'axios';
import { Dispatch } from 'react-redux';

import * as types from './actionTypes';
import { beginAjaxCall, ajaxCallError } from './ajaxStatusActions';
import { navigateToRoles } from './navigationActions';
import ResponseStatus from '../utils/responseStatus';
import { isLoaded } from '../reducers/roleReducer';
import Role from '../entities/role';
import roleItemTransformationBeforeSave from '../data-transformations/roleItemTransformationBeforeSave';

export const fetchRoles = () => async (dispatch: Dispatch<any>, getState: any) => {
    if (isLoaded(getState())) {
        return;
    }

    try {
        dispatch(beginAjaxCall());

        const response = await axios.get(`role/`);

        if (ResponseStatus.IsOK(response.status)) {
            dispatch({
                type: types.ROLE_FETCH,
                data: response.data,
            });
        } else {
            dispatch(ajaxCallError());
        }
    } catch (error) {
        dispatch(ajaxCallError());
        throw error;
    }
};

export const createRole = (data: Role) => (dispatch: Dispatch<any>) => {
    dispatch(beginAjaxCall());

    const transformedData = roleItemTransformationBeforeSave(data);

    axios
        .post(`role`, transformedData)
        .then((response) => {
            if (ResponseStatus.IsCreated(response.status)) {
                dispatch({
                    type: types.ROLE_ADD,
                });

                dispatch(navigateToRoles());
            } else {
                dispatch(ajaxCallError());
            }
        })
        .catch((error) => {
            dispatch(ajaxCallError());
            throw error;
        });
};

export const updateRole = (data: Role) => (dispatch: Dispatch<any>) => {
    dispatch(beginAjaxCall());

    const transformedData = roleItemTransformationBeforeSave(data);

    axios
        .put(`role`, transformedData)
        .then((response) => {
            if (ResponseStatus.IsOK(response.status)) {
                dispatch({
                    type: types.ROLE_UPDATE,
                    data: response.data,
                });

                dispatch(navigateToRoles());
            } else {
                dispatch(ajaxCallError());
            }
        })
        .catch((error) => {
            dispatch(ajaxCallError());
            throw error;
        });
};
